import { App, Plugin } from 'vue';
import { odsBox } from 'omind-design-system/components/odsBox';
import { odsButton } from 'omind-design-system/components/odsButton';
import { odsCard } from 'omind-design-system/components/odsCard';
import { odsCheckbox } from 'omind-design-system/components/odsCheckbox';
import { odsFieldMessage } from 'omind-design-system/components/odsFieldMessage';
import { odsIcon } from 'omind-design-system/components/odsIcon';
import { odsInput } from 'omind-design-system/components/odsInput';
import { odsLogo } from 'omind-design-system/components/odsLogo';
import { odsNavigation } from 'omind-design-system/components/odsNavigation';
import { odsPill } from 'omind-design-system/components/odsPill';
import { odsPopup } from 'omind-design-system/components/odsPopup';
import { odsSelect } from 'omind-design-system/components/odsSelect';
import { odsTextarea } from 'omind-design-system/components/odsTextarea';
import { odsRadar } from 'omind-design-system/components/odsRadar';
import { odsSwitch } from 'omind-design-system/components/odsSwitch';
import { odsDropdown } from 'omind-design-system/components/odsDropdown';

export {
  BorderRadius,
  Spacing,
  Shadow,
  FlexDirection,
  //FlexDirectionLiteral,
  Size,
  Align,
  Justify,
  AsidePosition,
} from 'omind-design-system/tokens';
export { ButtonColor, ButtonType, ButtonSize } from 'omind-design-system/components/odsButton';
export { LogoColor } from 'omind-design-system/components/odsLogo';
export { IconSize } from 'omind-design-system/components/odsIcon';
export { popupManager } from 'omind-design-system/components/odsPopup';

const ODS: Plugin = {
  install(Vue: App) {
    Vue.component('OdsBox', odsBox);
    Vue.component('OdsButton', odsButton);
    Vue.component('OdsCard', odsCard);
    Vue.component('OdsCheckbox', odsCheckbox);
    Vue.component('OdsFieldMessage', odsFieldMessage);
    Vue.component('OdsIcon', odsIcon);
    Vue.component('OdsInput', odsInput);
    Vue.component('OdsLogo', odsLogo);
    Vue.component('OdsNavigation', odsNavigation);
    Vue.component('OdsPill', odsPill);
    Vue.component('OdsPopup', odsPopup);
    Vue.component('OdsSelect', odsSelect);
    Vue.component('OdsTextarea', odsTextarea);
    Vue.component('OdsRadar', odsRadar);
    Vue.component('OdsSwitch', odsSwitch);
    Vue.component('OdsDropdown', odsDropdown);
  },
};

export default ODS;
